import api from './api';

// Échanges clients d'un dossier atelier.
// ⚠️ Préfixe /planning-echanges et non /planning : le verrou « pas de
// technicien » du routeur couperait le Planning entier s'il était monté sur
// /api/planning (constaté en recette).
export const planningEchanges = {
  // La conversation du dossier — regroupée par n° d'OR quand il existe.
  list: (interventionId) => api.get(`/planning-echanges/dossier/${interventionId}`),

  create: (interventionId, data) => api.post(`/planning-echanges/dossier/${interventionId}`, data),

  update: (echangeId, data) => api.put(`/planning-echanges/detail/${echangeId}`, data),

  // Tableau des derniers contacts (dossiers non restitués).
  derniersContacts: (jours = 90) =>
    api.get(`/planning-echanges/derniers-contacts?jours=${jours}`),

  // Clients sans contact depuis N jours (mêmes dossiers, filtrés sur le silence).
  // periode : '1m' | '3m' | '6m' | '9m' | '2026' (depuis le 1er janvier 2026).
  sansContact: ({ n = 7, periode = '2026', mode = 'tous' } = {}) =>
    api.get(`/planning-echanges/sans-contact?n=${n}&periode=${periode}&mode=${mode}`),

  sansContactCsv: ({ n = 7, periode = '2026', mode = 'tous' } = {}) =>
    api.get(`/planning-echanges/sans-contact?n=${n}&periode=${periode}&mode=${mode}&format=csv`, { responseType: 'blob' }),
};

export default planningEchanges;
